export default __webpack_public_path__ + "static/media/smaller_signiant.016f153c.png";